export default __webpack_public_path__ + "static/media/canimmunize.49f234aa.png";